/**
 * useModalManagement Composable
 * Handles all modal state management (Single Responsibility Principle)
 * Compatible with Vue 2 and Vue 3
 */

/**
 * Composable for managing modal states
 * @param {Object} store - Vuex store instance
 * @returns {Object} Modal management methods
 */
export function useModalManagement(store) {
  if (!store) {
    console.warn("useModalManagement: Store instance is required");
    return {
      setLocationModalOpen: () => {},
      setScheduleModalOpen: () => {},
      setItemModalOpen: () => {},
      setRestaurantClosedModalOpen: () => {}
    };
  }

  /**
   * Opens or closes location selection modal
   * @param {boolean} isOpen - Whether modal should be open
   */
  function setLocationModalOpen(isOpen) {
    store.dispatch("setLocationModalOpen", isOpen);
  }

  /**
   * Opens or closes schedule modal
   * @param {boolean} isOpen - Whether modal should be open
   */
  function setScheduleModalOpen(isOpen, options = {}) {
    store.dispatch("setScheduleModalOpen", { isOpen, options });
  }

  /**
   * Opens or closes item details modal
   * @param {Object|null} item - Item to show in modal, or null to close
   */
  function setItemModalOpen(item) {
    store.commit("SET_SELECTED_ITEM", item);
  }

  /**
   * Opens or closes restaurant closed modal
   * @param {boolean} isOpen - Whether modal should be open
   */
  function setRestaurantClosedModalOpen(isOpen) {
    store.dispatch("setRestaurantClosedModalOpen", isOpen);
  }

  /**
   * Gets the restaurant closed modal open state
   * @returns {boolean} True if modal is open
   */
  function getIsRestaurantClosedModalOpen() {
    return store.getters.isRestaurantClosedModalOpen || false;
  }

  return {
    setLocationModalOpen,
    setScheduleModalOpen,
    setItemModalOpen,
    setRestaurantClosedModalOpen,
    getIsRestaurantClosedModalOpen
  };
}
